import GuarantorList from './GuarantorList';

export default GuarantorList;
